import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import Sponsors from '../components/Sponsors';
import MenuPereira from '../components/MenuPereira';
import MenuItineraryPereira from '../components/MenuItineraryPereira';
import '../assets/styles/containers/SimpleSection.sass';

class SimpleSectionPereira extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      data: {},
    }
  }
  
  componentDidMount() {
    const {slug} = this.props.match.params;
    this.getData(slug);
  }

  componentWillReceiveProps(nextProps) {
    const {slug} = this.props.match.params;
    if(slug !== nextProps.match.params.slug) {
      this.getData(nextProps.match.params.slug);
    }
 }

  getData(slug) {
    fetch(`${process.env.REACT_APP_URL}/api/adventures/general/coffee-mtb/${slug}`)
    .then(res => res.json())
    .then(
      (res) => {
        this.setState({data: res});
      },
      (error) => {
        this.setState({error: error});
      }
    )
    return;
  }

  render() {
    const {data} = this.state;
    const {content, sponsors} = data;

    return (
      <Layout>
        <>
          <Banner id={60} city="coffee" thumb="logo_adventures.png"/>
          <MenuPereira />
          {this.props.itinerary &&
            <MenuItineraryPereira />
          }
          <div className="row content-min-height">
            {ReactHtmlParser(content?.content_es)}
          </div>
          {sponsors && (
            <Sponsors
              items={sponsors}
              city="pereira"
            />
          )}
        </>
      </Layout>
    );

  }
}

export default SimpleSectionPereira;
